import React, { useState } from 'react';
import { connect } from 'react-redux';
import { openChat } from '../../../store/actions/chat';
import { packageON, packageOFF, GA } from '../../../api/channels';
import { selectHostname } from '~/src/store/selectors/domain';

import {
    Wrapper,
    Title,
    Subtitle,
    Text,
    Radio,
    ButtonWrapper,
    Button,
    ButtonPink,
    Icon,
    CenterBlock,
} from './styled';

import IconSuccess from '../success.svg';
import IconError from '../sad.svg';

const pad = (n) => (`0${n}`).slice(-2);

const SubscribeControl = ({ data, onClose, onSuccess, openChat, auth: { clientPersonal, accessToken }, billingHost }) => {
    const [costId, costIdSetter] = useState(-1);
    const [stateForm, stateFormSetter] = useState({
        errorCode: '',
        isSuccess: false,
        action: data.action,
    });

    let dateToString = '';

    if (data.state.unsetFrom !== null) {
        const dTo = new Date(data.state.unsetFrom * 1000);
        dateToString = `${pad(dTo.getDate())}.${pad(dTo.getMonth() + 1)}.${dTo.getFullYear()}`;
    }

    const selectRaItem = (costId !== -1) ? data.costRa.find(el => el.raId === costId) : { cost: data.baseCost };
    const onChange = (value) => costIdSetter(value);
    const onErrorClick = () => {
        onClose();
        openChat();
    };
    const onOffClick = async() => {
        try {
            const result = await packageOFF({
                billingHost: billingHost,
                agreement_id: clientPersonal.agreementId,
                access_token: accessToken,
                tr_id: data.terminalId,
                packet: data.id,
                date_to: dateToString,
            });

            if (Number(result.status) !== 1) {
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: result.errorCode,
                    isSuccess: false,
                }));
            } else {
                GA({
                    action: 'disable a channel subscription',
                    label: data.name,
                });

                onSuccess();
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: '',
                    isSuccess: true,
                }));
            }
        } catch (e) {
            stateFormSetter((prev) => ({
                ...prev,
                errorCode: 'Error',
                isSuccess: false,
            }));
        }
    };

    const onClickToOn = () => {
        stateFormSetter((prev) => ({
            ...prev,
            action: 'on',
        }));

        GA({
            action: 'click prolong subscriptions on the btn extend',
            label: `${data.name}, ${selectRaItem.duration ? `подписка на ${selectRaItem.duration} мес` : 'базовая цена'}`
        });
    };

    const onOnClick = async() => {
        try {
            let date_from = undefined;

            if (data.state.dateTo !== null) {
                const dFrom = new Date(data.state.dateTo * 1000);
                date_from = `${pad(dFrom.getDate())}.${pad(dFrom.getMonth() + 1)}.${dFrom.getFullYear()}`;
            }

            GA({
                action: 'click prolong subscriptions on the btn confirm',
                label: `${data.name}, ${selectRaItem.duration ? `подписка на ${selectRaItem.duration} мес` : 'базовая цена'}`,
            });

            const result = await packageON({
                billingHost: billingHost,
                access_token: accessToken,
                packet: data.id,
                tr_id: data.terminalId,
                date_from,
                ra_id: selectRaItem.raId,
                close_packet: (selectRaItem.raId) ? 1 : undefined,
            });

            if (Number(result.status) !== 1) {
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: result.errorCode,
                    isSuccess: false,
                }));

                GA({
                    action: 'error connect the channel',
                    label: `${data.name}, ${selectRaItem.duration ? `подписка на ${selectRaItem.duration} мес` : 'базовая цена'}`,
                });
            } else {
                GA({
                    action: 'successful prolong subscriptions',
                    label: `${data.name}, ${selectRaItem.duration ? `подписка на ${selectRaItem.duration} мес` : 'базовая цена'}`,
                });

                onSuccess();
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: '',
                    isSuccess: true,
                }));
            }
        } catch (e) {
            stateFormSetter((prev) => ({
                ...prev,
                errorCode: 'Error',
                isSuccess: false,
            }));
        }
    };

    const options = [
        {
            value: -1,
            label: `продлить по базовой цене на 1 мес. ${data.baseCost} ₽`,
        }
    ];

    data.costRa.forEach((item_) => {
        const item = item_;
        item.value = Number(item_.raId),
        item.label = `продлить на ${item.duration} мес. ${item.cost} ₽`;
        options.push(item);
    });

    let content = (
        <React.Fragment>
            <Title>Продлить пакет</Title>
            { options.length > 1 ? (<Subtitle>Выберите один из вариантов продления</Subtitle>) : null }
            {
                options.map(item => (
                    <Radio
                        name='subscribeControlRadio'
                        key={item.value}
                        value={item.value}
                        label={item.label}
                        checked={costId === item.value}
                        onChange={onChange.bind(this, item.value)}
                    />
                ))
            }
            <ButtonWrapper>
                <Button type='primary' text='Продлить' onClick={onClickToOn}/>
                <ButtonPink type='primary' text='Отключить пакет' onClick={() => {
                    stateFormSetter((prev) => ({ ...prev,  action: 'off' }));
                }}/>
            </ButtonWrapper>
        </React.Fragment>
    );

    if (stateForm.action === 'on') {
        const textEnd = (selectRaItem.duration) ? `на ${selectRaItem.duration}&nbsp;мес. за ${selectRaItem.cost}&nbsp;₽` : `за ${selectRaItem.cost}&nbsp;₽`;

        content = (
            <React.Fragment>
                <Title>Подтвердите заявку на продление</Title>
                <Text dangerouslySetInnerHTML={{ __html: `Вы хотите продлить подписку пакета канала «${data.name}» ${textEnd}` }} />
                <ButtonWrapper>
                    <Button type='primary' text='Подтвердить' onClick={onOnClick}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    }

    if (stateForm.action === 'off') {
        const textEnd = (dateToString !== '') ? `Дата отключения пакета ${dateToString}` : '';

        content = (
            <React.Fragment>
                <Title>Подтвердите заявку на отключение</Title>
                <Text>{`Вы хотите отключить пакет каналов «${data.name}». ${textEnd}`}</Text>
                <ButtonWrapper>
                    <Button type='primary' text='Подтвердить' onClick={onOffClick}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    }

    if (stateForm.errorCode !== '') {
        let errorText = '';

        if (stateForm.action === 'off') {
            errorText = 'Возникла ошибка при отключении пакета каналов. Напишите в чат техподдержки, мы поможем.';
            if (stateForm.errorCode === 'INITIAL_PERIOD_STILL_ACTIVE') {
                errorText = 'Минимальный срок использования пакета каналов - 30 дней. Пакет можно отключить по истечении этого времени. Если остались вопросы, напишите в чат техподдержки.';
            } else if (stateForm.errorCode === 'DEACTIVATION_DATE_ALREADY_SET') {
                errorText = `Невозможно отключить пакет каналов будущей датой - дата отключения уже установлена. ${(dateToString !== '') ? `Пакет каналов будет отключен ${dateToString}` : ''}`;
            } else if (stateForm.errorCode === 'CANT_DEACTIVATE_SPECIAL_OFFER') {
                errorText = 'Невозможно отключить пакет каналов, подключенный по рекламной акции. Если остались вопросы, напишите в чат техподдержки.';
            }
        } else if (stateForm.action === 'on') {
            errorText = 'Возникла ошибка при продлении пакета каналов. Напишите в чат техподдержки, мы поможем.';
            if (stateForm.errorCode === 'INSUFFICIENT_DEBIT_BALANCE') {
                errorText = 'Недостаточно средств для продления пакета каналов. Пожалуйста пополните счет.';
            } else if (stateForm.errorCode === 'PACKET_ALREADY_ACTIVE') {
                errorText = 'Пакет каналов уже подключен';
            }
        }

        content = (
            <React.Fragment>
                <Icon src={IconError} alt='Error'/>
                <CenterBlock>
                    <Title>Произошла ошибка ...</Title>
                    <Text>{errorText}</Text>
                </CenterBlock>
                <ButtonWrapper>
                    <Button type='primary' text='Написать в чат' onClick={onErrorClick}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    } else if (stateForm.isSuccess === true) {
        const durationStr = (costId === -1) ? '.' : ` на ${selectRaItem.duration} мес.`;

        content = (
            <React.Fragment>
                <Icon src={IconSuccess} alt='Success'/>
                <CenterBlock>
                    {
                        (stateForm.action === 'off') ? (
                            <React.Fragment>
                                <Title>Пакет каналов успешно отключен</Title>
                                <Text>{`Пакет каналов «${data.name}» будет отключен ${dateToString}`}</Text>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <Title>Пакет каналов успешно продлен</Title>
                                <Text>{`Пакет каналов «${data.name}» продлен${durationStr}`}</Text>
                            </React.Fragment>
                        )
                    }
                </CenterBlock>
                <ButtonWrapper>
                    <Button type='primary' text='Спасибо' onClick={onClose}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    }

    return (
        <Wrapper>{content}</Wrapper>
    );
};

const mapStateToProps = ({ city, auth }) => ({
    billingHost: selectHostname({ auth, city }),
    auth,
});

const mapDispatchToProps = (dispatch) => ({
    openChat: () => dispatch(openChat())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SubscribeControl);
